import React, {useEffect} from 'react';
import FormTextArea from "../../layout/ui/FormTextArea";
import FormSelect from "../../layout/ui/FormSelect";
import {useNotifications} from "../../../providers/NotificationsProvider";
import {useApi} from "../../../providers/ApiProvider";
import ProjectsRequests from "../../../requests/ProjectsRequests";
import ProjectAccessTokensRequests from "../../../requests/ProjectAccessTokensRequests";
import FormTextField from "../../layout/ui/FormTextField";
import ButtonWithLoading from "../../layout/ui/ButtonWithLoading";

export default function ProjectShareModalFeaturedCreateLink({onChange = () => {}, projectId = '', className = ''}) {
    const notificationsContext = useNotifications();
    const apiContext = useApi();
    const projectAccessTokensRequests = new ProjectAccessTokensRequests(apiContext.api, projectId);

    const ACCESS_LEVEL_READ = 'read';
    const ACCESS_LEVEL_EDIT = 'edit';

    const [notes, setNotes] = React.useState('');
    const [accessLevel, setAccessLevel] = React.useState(ACCESS_LEVEL_READ);
    const [loading, setLoading] = React.useState(false);
    const [errors, setErrors] = React.useState({});


    const onSubmitLocal = (e) => {
        e.preventDefault();

        if (!accessLevel || [ACCESS_LEVEL_READ, ACCESS_LEVEL_EDIT].indexOf(accessLevel) === -1) {
            setErrors({access_level: ['Please select access level.']});
            return false;
        }
        setErrors({});

        let data = {
            project_id: projectId,
            access_level: accessLevel,
            notes: notes
        };

        setLoading(true);

        projectAccessTokensRequests.create(data).then((response) => {
            if (response !== false) {
                notificationsContext.notify('Access granted successfully.', 'success');
                onChange();
            } else {
                notificationsContext.notify('Error granting access.', 'error');
            }
        }).finally(() => {
            setLoading(false);
        });
    }


    return (
        <form className={className + ''} onSubmit={onSubmitLocal}>
            <h4 className="fs-4 fw-semibold">Create a new Share Link</h4>

            <div className="d-flex flex-row gap-2">
                <div style={{width: '200px'}}>
                    <FormSelect
                        label="Access Level"
                        name="access_level"
                        value={accessLevel}
                        options={[
                            {value: ACCESS_LEVEL_READ, label: 'Can View'},
                            {value: ACCESS_LEVEL_EDIT, label: 'Can Edit'},
                        ]}
                        onChange={(value) => setAccessLevel(value)}
                        groupClassName="mb-3"
                    />
                </div>

                <FormTextField
                    label="Link notes"
                    value={notes ? notes : ''}
                    onChange={(value) => setNotes(value)}
                    hint="Only you can see these notes."
                    groupClassName="mb-3 flex-grow-1"
                />
            </div>
            <div className="d-flex flex-row justify-content-end w-100">
                <ButtonWithLoading
                    className="btn btn-primary"
                    label="Create a link"
                    noOriginalIconClassName={true}
                    onClick={onSubmitLocal}
                    loading={loading}
                />
            </div>
        </form>
    );
}
